﻿import * as Features from '../../../shared/Features';

export function shouldShowGoToOrderButton(orderId: number | null, user: any): boolean {
    if (orderId) {
        return (
            Features.hasFeature(Features.ViewOrder, user) ||
            Features.hasFeature(Features.ViewStylingOrder, user)
        );
    }

    return false;
}
